import React, { CSSProperties } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import {
  ButtonTertiary,
  ColoredIllustrationSuccess,
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui';
import { ContainerTemplate } from '@/components';
import { useLocation } from 'react-router-dom';
import { getDecodedWidgetToken } from '@/utils/widget';
import { parseReturnUrl } from './MerchantVerification.utils';

export const VerificationSuccess = ({ t }: any): React.JSX.Element => {
  const { search } = useLocation();
  const tPrefix = 'products-fe.containers.merchant_verification_success';
  const tPrefixOverview = 'products-fe.containers.merchant_verification_overview';
  const queryParams = new URLSearchParams(search);
  const decodedWidgetToken = getDecodedWidgetToken();
  const returnUrl = queryParams.get('return_url') || decodedWidgetToken?.returnUrl;

  const styles = {
    verificationInfoWrapper: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column' as CSSProperties['flexDirection'],
    },
  };

  const onButtonClick = () => {
    if (returnUrl) {
      const parsedUrl = parseReturnUrl(returnUrl);
      if (parsedUrl) {
        window.location.href = parsedUrl;
      }
    } else {
      window.close();
    }
  };

  return (
    <ContainerTemplate showRecaptchaFooter>
      <ColoredIllustrationSuccess />
      <SpacerVertical spaceToken="space/400" />
      <Typography textToken="text-style/headings/titles/bold/huge">
        {t(`${tPrefix}.title`)}
      </Typography>
      <SpacerVertical spaceToken="space/400" />
      <Typography textToken="text-style/text/labels/tall/regular">
        {t(`${tPrefix}.subtitle`)}
      </Typography>
      <SpacerVertical spaceToken="space/400" />
      <div style={styles.verificationInfoWrapper}>
        <Typography textToken="text-style/text/labels/grande/bold">
          {t(`${tPrefixOverview}.infos.review.title`)}
        </Typography>
        <SpacerVertical spaceToken="space/100" />
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {t(`${tPrefixOverview}.infos.review.description`)}
        </Typography>
      </div>
      <SpacerVertical spaceToken="space/800" />
      <ButtonTertiary onClick={() => onButtonClick()} onPress={() => onButtonClick()}>
        {t('products-fe.containers.merchant_verification_info.button_close')}
      </ButtonTertiary>
    </ContainerTemplate>
  );
};

VerificationSuccess.propTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  t: translator(state),
}))(VerificationSuccess);
